module.exports = __webpack_public_path__ + "img/background.aa26b1b1.png";